export enum EProcessStatus {
  NEW = "N",
  SPLITTING = "S",
  SPLIT = "U",
  PREPARING = "P",
  PREPARED = "V",
  WAIT_FOR_FORKLIFT = "B",
  HOLDING = "A",
  WAIT_FOR_RECEIVE = "X",
  RECEIVED = "R",
  RETURN = "T",
}
